import errorManager from '@/rollbar.js';

const getDecodesConfigId = function (businessUnitId) {
  if (window.location.href.includes('edit')) {
    var drugConfigId = $('#drug_id_select').val();
    getMaxDailyQuantityDrug(businessUnitId, drugConfigId);
    onChangeDrug(businessUnitId, drugConfigId);
  } else {
    onChangeDrug(businessUnitId, drugConfigId);
  }
};

const getMaxDailyQuantityDrug = function (businessUnitId, drugConfigId) {
  $.ajax({
    url: '/' + window.locale + '/drugs_configs/max_daily_quantity/',
    data: {
      business_unit_id: businessUnitId,
      drug_config_id: drugConfigId,
    },
    cache: false,
    type: 'GET',
    success: function (response) {
      let maxDailyQuantity = response.max_daily_q;
      let maxDailyUnit = response.max_daily_unit;
      if (maxDailyQuantity) {
        showMaxDailyQ(maxDailyQuantity, maxDailyUnit);
      }
    },
    error: function (xhr) {
      console.log('Errore nel caricamento delle DrugsConfigs');
    },
  });
};

const showMaxDailyQ = (maxDailyQuantity, maxDailyUnit) => {
  var maxDoseLabel = document.getElementById('max_daily_quantity');
  maxDoseLabel.classList.remove('hidden');
  var maxDoseInput = document.getElementById('max_daily_quantity_value');
  var maxDailyU = maxDailyUnit !== null ? maxDailyUnit : '';
  maxDoseInput.value = maxDailyQuantity.toString() + maxDailyU;
};

const onChangeDrug = (businessUnitId, drugConfigId) => {
  eventBus.$on('new_drug_selected_on_guest_drugs', (drugConfigId) => {
    getMaxDailyQuantityDrug(businessUnitId, drugConfigId);
  });
};

const init = (businessUnitId) => {
  () => {
    return window.i18nJS;
  };

  try {
    getDecodesConfigId(businessUnitId);
  } catch (e) {
    errorManager(e);
  }
};

window.OverdoseControl = {
  init: init,
};
